import * as React from 'react';
import { TextField, Checkbox, FormControlLabel, Button, InputLabel, MenuItem, Select, Switch } from '@mui/material';

import { useContext, useState } from 'react'

import './AddCustomer.css'

import { FirebaseContext } from '../../Services/firebase'

import { defaultCustomerData } from '../../Config/defaultCustomerData';

export default function AddCustomer(props) {

    const firebase = useContext(FirebaseContext)

    const [CustomerData, setCustomerData] = useState(defaultCustomerData);

    const handleChangeOrigin = (event) => {
        setCustomerData({...CustomerData, origin: event.target.value})
    };

    const handleChange = e => {
        setCustomerData({...CustomerData, [e.target.id]: e.target.value})
    }

    const handleCheck = e => {
        setCustomerData({...CustomerData, [e.target.id]: e.target.checked})
    }

    const handleGender = (event) => {
        setCustomerData({...CustomerData, gender: event.target.value})
    };

    function createCustomer() {
        try {
            firebase.newCustomer(props.UserSession.uid, CustomerData)
            .then(
                alert('Le client a bien été créé'),
                setCustomerData({...defaultCustomerData}),
            )
            .catch(error => {
                alert(error.message)
            })
        }catch(err) {
            alert(err)
        }
    }     

    return (
        <div className="AddClientForm">
            <h2>Infos client</h2>
            <div className="row">
                <TextField style={{width: "15vw", marginRight: "1vw"}} required type="text" id="nbr" name="nbr" value={CustomerData.nbr} onChange={handleChange} label="Numéro de client" variant="outlined"/>
                <TextField style={{width: "15vw"}} required type="text" id="num" name="num" value={CustomerData.num} onChange={handleChange} label="Téléphone" variant="outlined"/>
            </div>
            <div className="row">
                <Select
                    style={{width: "5vw", marginRight: "1vw", textAlign: "left"}}
                    id="gender"
                    name="gender"
                    value={CustomerData.gender}
                    label="Genre"
                    onChange={handleGender}
                >
                    <MenuItem value={'M.'}>M.</MenuItem>
                    <MenuItem value={'Mme.'}>Mme.</MenuItem>
                </Select>
                <TextField style={{width: "15vw", marginRight: "1vw"}} required type="text" id="name" name="name" value={CustomerData.name} onChange={handleChange} label="Nom" variant="outlined"/>
                <TextField style={{width: "15vw"}} required type="text" id="firstname" name="firstname" value={CustomerData.firstname} onChange={handleChange} label="Prénom" variant="outlined"/>
            </div>
            <div className="row">
                <TextField style={{width: "15vw", marginRight: "1vw"}} required type="text" id="adresse" name="adresse" value={CustomerData.adresse} onChange={handleChange} label="Adresse" variant="outlined"/>
                <TextField style={{width: "7vw", marginRight: "1vw"}} required type="text" id="code" name="code" value={CustomerData.code} onChange={handleChange} label="Code postale" variant="outlined"/>
                <TextField style={{width: "7vw"}} required type="text" id="ville" name="ville" value={CustomerData.ville} onChange={handleChange} label="Ville" variant="outlined"/>
            </div>
            <div className="row">
            <TextField
                id="dateString"
                label="Dâte de naissance"
                type="date"
                value={CustomerData.dateString}
                sx={{ width: 220 }}
                InputLabelProps={{
                shrink: true,
                }}
                onChange={handleChange}
            />
            </div>
            <div className="row">
                <TextField style={{width: "15vw", marginRight: "1vw"}} required type="text" id="type" name="type" value={CustomerData.type} onChange={handleChange} label="Type de logement" variant="outlined"/>
                <TextField style={{width: "25vw"}} required type="text" id="acces" name="accès" value={CustomerData.acces} onChange={handleChange} label="Accès" variant="outlined"/>
            </div>
            <label style={{marginTop: "1vh"}}>Type de prestation:</label>
            <div className="row">
                <FormControlLabel control={<Checkbox id="repas" value={CustomerData.repas} onChange={handleCheck}/>} label="Portage de repas" />
                <FormControlLabel control={<Checkbox id="menage" value={CustomerData.menage} onChange={handleCheck} />} label="Ménages" />
                <FormControlLabel control={<Checkbox id="bricolage" value={CustomerData.bricolage} onChange={handleCheck}/>} label="Bricolage" />
                <FormControlLabel control={<Checkbox id="admin" value={CustomerData.admin} onChange={handleCheck} />} label="Aide administrative" />
                <FormControlLabel control={<Checkbox id="courses" value={CustomerData.courses} onChange={handleCheck} />} label="Courses" />
            </div>
            <label style={{marginTop: "1vh"}}>Type de paiement:</label>
            <div className="row">
                <FormControlLabel control={<Checkbox id="cheque" value={CustomerData.cheque} onChange={handleCheck} />} label="Chèque" />
                <FormControlLabel control={<Checkbox id="prelevement" value={CustomerData.prelevement} onChange={handleCheck} />} label="Prélèvement" />
                <FormControlLabel control={<Checkbox id="virement" value={CustomerData.virement} onChange={handleCheck} />} label="Virement" />
            </div>
            <h2>Infos aidant</h2>
            <TextField style={{width: "30vw"}} required type="text" id="infosAidant" name="infos" value={CustomerData.infosAidant} onChange={handleChange} label="Informations" variant="outlined"/>
            <TextField style={{width: "15vw", marginTop: "1vh"}} required type="text" id="numAidant" name="numAidant" value={CustomerData.numAidant} onChange={handleChange} label="Téléphone" variant="outlined"/>
            <h2>Autres</h2>
            <div className="row">
                <FormControlLabel control={<Checkbox id="apa" value={CustomerData.apa} onChange={handleCheck} />} label="A.P.A" />
                <FormControlLabel control={<Checkbox id="alarme" value={CustomerData.alarme} onChange={handleCheck} />} label="Télé-alarme" />
                <FormControlLabel control={<Checkbox id="contrat" value={CustomerData.contrat} onChange={handleCheck} />} label="Contrat" />
                <FormControlLabel control={<Checkbox id="mandat" value={CustomerData.mandat} onChange={handleCheck} />} label="Mandat" />
            </div>
            <div className="row">
            <TextField
                id="firstDate"
                label="Dâte de première livraison"
                type="date"
                value={CustomerData.firstDate}
                sx={{ width: 220, marginRight: "1vw"}}
                InputLabelProps={{
                shrink: true,
                }}
                onChange={handleChange}
            />
            <TextField
                id="lastDate"
                label="Dâte de fin"
                type="date"
                value={CustomerData.lastDate}
                sx={{ width: 220 }}
                InputLabelProps={{
                shrink: true,
                }}
                onChange={handleChange}
            />
            </div>
            <InputLabel id="originLabel">Origine de la piste</InputLabel>
            <Select
                labelId="origin"
                id="origin"
                value={CustomerData.origin}
                label="Origine de la piste"
                onChange={handleChangeOrigin}
                sx={{width: "15vw"}}
            >
                <MenuItem value="Internet">Internet</MenuItem>
                <MenuItem value="Clients">Clients</MenuItem>
                <MenuItem value="Assistante sociale">Assistante sociale</MenuItem>
                <MenuItem value="Médicale">Médicale</MenuItem>
                <MenuItem value="Bouche à oreille">Bouche à oreille</MenuItem>
                <MenuItem value="Autre">Autre</MenuItem>
            </Select>
            <TextField style={{width: "30vw", marginTop: "1vh"}}  type="text" id="comment" name="comment" value={CustomerData.comment} onChange={handleChange} label="Commentaire" variant="outlined"/>
            <FormControlLabel control={<Switch defaultChecked={CustomerData.actif} />} label="actif" />
            <TextField style={{width: "30vw", marginTop: "1vh"}}  type="text" id="tourNum" name="tourNum" value={CustomerData.tourNum} onChange={handleChange} label="Numéro de tournée" variant="outlined"/>
            <Button style={{marginTop: "1vh"}} variant="contained" onClick={createCustomer}>Ajouter</Button>
        </div>
    )         
}